import React, { useRef } from "react";
import { DownOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useStores } from "@/store";
import "./index.less";
import { useState } from "react";

/**
 * 餐厅信息
 *
 * @returns
 */
const Restaurant = (restaurant = {}) => {
  const { t } = useTranslation();
  const { memberStore } = useStores();
  const [distance, setDistance] = useState("");
  let {
    cover,
    tags,
    ratings_avg,
    name,
    avg_price,
    cuisines,
    region,
    lat,
    lng,
    location,
  } = restaurant;

  const price = `${region?.currency || '￥'}${parseInt(avg_price, 10)}/p.p`;
  const rate = parseFloat(ratings_avg, 10).toFixed(1);
  /**查看餐厅详情 */
  function onRestaurantClick() {
    window.open(restaurant.website_detail_url, "_blank");
  }
  useEffect(() => {
    setDistance(memberStore.getDistance(lat, lng));
  }, [memberStore.position]);

  cover = `${cover}?imageView2/1/w/88/h/64/interlace/1`.replace('??', '?')

  return (
    <article className="dc-restaurant" onClick={onRestaurantClick}>
      <div className="dc-restaurant--image">
        <img src={cover} width="82" height="60" />
      </div>
      <div className="dc-restaurant--content">
        <Cuisines cuisines={cuisines} />
        <div className="dc-restaurant--name">{name}</div>
        <div className="dc-restaurant--price small">{price}</div>
        <div className="dc-restaurant--rate">
          <strong>{rate}</strong>
          <span className="small">{t("RATING")}</span>
        </div>
        <div className="dc-restaurant--address">
          <span>
            <i className="icon icon-location"></i>
            <span className="small">{location.name}</span>
          </span>
          <span className="dc-restaurant--distance small">{distance}</span>
        </div>
        <Tags tags={tags} />
      </div>
    </article>
  );
};

const Cuisines = ({ cuisines }) => {
  let max = cuisines.length - 1;
  return (
    <div className="dc-restaurant--cuisines small ellipsis">
      {cuisines.map((item, index) => {
        return (
          <React.Fragment key={item.name}>
            <span>{item.name}</span>
            {index < max && <i></i>}
          </React.Fragment>
        );
      })}
    </div>
  );
};

const Tags = ({ tags, onClick }) => {
  let size = tags.length;
  let tagWrapper = useRef();
  function onClick() {
    tagWrapper.current.classList.toggle("show-all");
  }
  return (
    <div className="dc-restaurant--tags" ref={tagWrapper}>
      {tags.map((item, index) => {
        return (
          <div className="restaurant-tag" key={index}>
            <div className="tag-icon">
              <img src={item.icon_url} width="12" height="12" />
              <span className="small">{item.name}</span>
            </div>
            {size > 1 && index === 0 && <DownOutlined onClick={onClick} />}
          </div>
        );
      })}
    </div>
  );
};

export default Restaurant;
